<template>
  <vue-admin-tasks-saved-task-card v-if="taskData.created && !taskData.editing" :task-data="taskData"></vue-admin-tasks-saved-task-card>
  <vue-admin-tasks-form-task-card v-else :task-data="taskData"></vue-admin-tasks-form-task-card>
</template>
<script>
export default{
  props: {
    taskData: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
